<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-button class="float-right" type="line" size="large" @click="showLocalizationsDialog = true" color="primary" icon="edit" ></vs-button>
        <vs-input
          disabled="true"
          class="w-3/4"
          :label-placeholder="`Name`"
          :value="helpers.getPreferredName(cyclopedia)"
        />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-textarea
          disabled
          :label="`Description`"
          :value="helpers.getPreferredDescription(cyclopedia)"
          height="175"
          style="color: darkgray;"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <ItoviImageUpload
          :initial-image-url="helpers.getImage(cyclopedia)"
          :identifier="'product'"
          :required-aspect-ratio="1"
          label-top="1:1 aspect ratio required (i.e. 500x500)"
          button-text="Book Image"
          @imageSelected="uploadProductImage"
        ></ItoviImageUpload>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <ItoviImageUpload
          :initial-image-url="helpers.getImage(cyclopedia, 'hero')"
          :identifier="'hero'"
          :required-aspect-ratio="1.71"
          label-top="12:7 aspect ratio required (i.e. 1080x630)"
          button-text="Hero Image"
          @imageSelected="uploadHeroImage"
        ></ItoviImageUpload>
      </div>
    </div>

    <vs-prompt
      buttons-hidden
      :title="cyclopedia.name"
      :active.sync="showLocalizationsDialog">
      <div class="modal-lg">
        <CyclopediaLocalizationsCard :cyclopedia="cyclopedia"
                                     v-on:cyclopediaUpdated="bubbleCyclopediaUpdated"
        ></CyclopediaLocalizationsCard>
      </div>
    </vs-prompt>

  </vx-card>
</template>

<script>
  import api from '@/http/api';
  import types from '@/models';
  import {cyclopediaHelpers} from '@/models/helpers'
  import CyclopediaLocalizationsCard from './CyclopediaLocalizationsCard';
  import ItoviImageUpload from '../../../../layouts/components/ItoviImageUpload';

  export default {
    components: {
      CyclopediaLocalizationsCard,
      ItoviImageUpload,
    },
    data() {
      return {
        showLocalizationsDialog: false,
        helpers: cyclopediaHelpers,
      }
    },
    props: {
      cyclopedia: {
        type: types.Cyclopedia,
        required: true,
      },
    },
    methods: {
      async uploadProductImage(image) {
        console.log('uploadProductImage()...');
        let images = await api.postCyclopediaProductImage(this.cyclopedia, image);
        if (images === null) {
          this.showNotification(false, 'Error uploading image');
        } else {
          this.cyclopedia.images = images;
          this.showNotification(true, 'Image uploaded');
        }
      },
      async uploadHeroImage(image) {
        console.log('uploadHeroImage()...');
        let images = await api.postCyclopediaHeroImage(this.cyclopedia, image);
        if (images === null) {
          this.showNotification(false, 'Error uploading image');
        } else {
          this.cyclopedia.images = images;
          this.showNotification(true, 'Image uploaded');
        }
      },
      bubbleCyclopediaUpdated(cyclopedia) {
        this.$emit('cyclopediaUpdated', cyclopedia);
        this.showLocalizationsDialog = false;
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'
        });
      },
    }
  }
</script>

<style lang="scss" scoped>

  .center-container {
    position: relative;
  }
  .upload-button-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .product-image {
    object-fit: scale-down;
    object-position: 50% 50%;
    width: 100%;
    max-height: 150px;
  }
</style>
